/** Generated js for domain-specific scripting
 * by common\modules\domains\helpers\DomainJavascriptWriter
 */

class BeforeAfter {
    constructor(enteryObject) {

        const beforeAfterContainer = document.querySelector(enteryObject.id);
        const before = beforeAfterContainer.querySelector('.bal-before');
        const beforeText = beforeAfterContainer.querySelector('.bal-beforePosition');
        const afterText = beforeAfterContainer.querySelector('.bal-afterPosition');
        const handle = beforeAfterContainer.querySelector('.bal-handle');
        var widthChange = 0;

        beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
        window.onresize = function () {
            beforeAfterContainer.querySelector('.bal-before-inset').setAttribute("style", "width: " + beforeAfterContainer.offsetWidth + "px;")
        }
        before.setAttribute('style', "width: 50%;");
        handle.setAttribute('style', "left: 50%;");

        //touch screen event listener
        beforeAfterContainer.addEventListener("touchstart", (e) => {

            beforeAfterContainer.addEventListener("touchmove", (e2) => {
                let containerWidth = beforeAfterContainer.offsetWidth;
                let currentPoint = e2.changedTouches[0].clientX;

                let startOfDiv = beforeAfterContainer.offsetLeft;

                let modifiedCurrentPoint = currentPoint - startOfDiv;

                if (modifiedCurrentPoint > 10 && modifiedCurrentPoint < beforeAfterContainer.offsetWidth - 10) {
                    let newWidth = modifiedCurrentPoint * 100 / containerWidth;

                    before.setAttribute('style', "width:" + newWidth + "%;");
                    afterText.setAttribute('style', "z-index: 1;");
                    handle.setAttribute('style', "left:" + newWidth + "%;");
                }
            });
        });

        //mouse move event listener
        beforeAfterContainer.addEventListener('mousemove', (e) => {
            let containerWidth = beforeAfterContainer.offsetWidth;
            widthChange = e.offsetX;
            let newWidth = widthChange * 100 / containerWidth;

            if (e.offsetX > 10 && e.offsetX < beforeAfterContainer.offsetWidth - 10) {
                before.setAttribute('style', "width:" + newWidth + "%;");
                afterText.setAttribute('style', "z-index:" + "1;");
                handle.setAttribute('style', "left:" + newWidth + "%;");
            }
        })

    }
}
if (document.querySelector('#beforeafterslider')) {
    new BeforeAfter({
        id: '#beforeafterslider'
    });
}


document.addEventListener('click', function (event) {
  var isExpandButton = event.target.matches('expand-button') || event.target.closest('.expand-button') != null;
  var expanderParent = event.target.closest('.expander');
  if (isExpandButton && expanderParent !== null) {
    event.preventDefault();
    toggleExpander(expanderParent, true);
  }
});
var toggleExpander = function toggleExpander(expanderElement, toggle) {
  if (toggle) {
    expanderElement.classList.toggle('expand');
  }
  var maxHeight = "999em";
  if (!expanderElement.classList.contains('expand')) {
    var _expanderElement$data;
    maxHeight = (_expanderElement$data = expanderElement.dataset.minimalHeight) !== null && _expanderElement$data !== void 0 ? _expanderElement$data : "50px";
  }
  var contentElement = expanderElement.querySelector('.expander-content');
  contentElement.style.maxHeight = maxHeight;
};
var expanders = document.querySelectorAll('.expander');
var _iterator = _createForOfIteratorHelper(expanders),
  _step;
try {
  for (_iterator.s(); !(_step = _iterator.n()).done;) {
    var expander = _step.value;
    toggleExpander(expander, false);
  }
} catch (err) {
  _iterator.e(err);
} finally {
  _iterator.f();
}